__webpack_require__.p = "https://us-west-2.gamma.categorymanagement.wwgs.amazon.dev/";